import type { ViewName } from '../app';

interface AppShellProps {
    currentView: ViewName;
    onNavigate: (view: ViewName) => void;
    canNavigateToPractice: boolean;
}

export function AppShell({ currentView, onNavigate, canNavigateToPractice }: AppShellProps) {
    const isUpload = currentView === 'upload' || currentView === 'character';
    const isPractice = currentView === 'practice' || currentView === 'readthrough' || currentView === 'record';
    const isEdit = currentView === 'edit';

    return (
        <header className="app-header">
            <a
                href="#"
                className="brand"
                aria-label="runlines home"
                onClick={(e) => { e.preventDefault(); onNavigate('upload'); }}
            >
                <span className="brand-glyph" aria-hidden="true"></span>
                <span className="brand-wordmark">runlines</span>
            </a>
            <nav className="step-nav" aria-label="App sections">
                <button
                    className={`step ${isUpload ? 'active' : (isPractice || isEdit) ? 'completed' : ''}`}
                    type="button"
                    onClick={() => onNavigate('upload')}
                >
                    Upload Script
                </button>
                <button
                    className={`step ${isPractice ? 'active' : isEdit ? 'completed' : ''} ${!canNavigateToPractice ? 'disabled' : ''}`}
                    type="button"
                    disabled={!canNavigateToPractice}
                    onClick={() => canNavigateToPractice && onNavigate('practice')}
                >
                    Practice
                </button>
                <button
                    className={`step ${isEdit ? 'active' : ''} ${!canNavigateToPractice ? 'disabled' : ''}`}
                    type="button"
                    disabled={!canNavigateToPractice}
                    onClick={() => canNavigateToPractice && onNavigate('edit')}
                >
                    Edit
                </button>
            </nav>
        </header>
    );
}
